import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Card, Typography, message, Spin, Tag, Divider } from 'antd';
import { ArrowLeftOutlined, UserOutlined, TeamOutlined } from '@ant-design/icons';
import { classAPI } from '../../services/api';
import axios from 'axios';
import CourseScheduleManagement from './CourseScheduleManagement';
import DutyStudentManagement from './DutyStudentManagement';
import SeatManagement from './SeatManagement';
import StudentBindingManagement from './StudentBindingManagement';
import ClassQRCodeManagement from './ClassQRCodeManagement';

const { Title } = Typography;
const { TabPane } = Tabs;

const ClassDetailManagement = () => {
  const { classId } = useParams();
  const navigate = useNavigate();
  const [classInfo, setClassInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('info');

  useEffect(() => {
    if (classId) {
      fetchClassInfo();
    }
  }, [classId]);

  const fetchClassInfo = async () => {
    try {
      setLoading(true);
      const response = await classAPI.getById(classId);
      if (response.data.success) {
        setClassInfo(response.data.data);
      } else {
        message.error('获取班级信息失败');
      }
    } catch (error) {
      console.error('获取班级信息失败:', error);
      message.error('获取班级信息失败');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!classInfo) {
    return (
      <Card>
        <p>班级信息不存在</p>
      </Card>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center' }}>
          <ArrowLeftOutlined 
            style={{ fontSize: 18, marginRight: 16, cursor: 'pointer' }}
            onClick={() => navigate('/classes')}
          />
          <Title level={3} style={{ margin: 0 }}>
            {classInfo.name} - 班级管理
          </Title>
        </div>

        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="基本信息" key="info">
            <div style={{ padding: '20px 0' }}>
              <p><strong>班级名称：</strong>{classInfo.name}</p>
              <p><strong>年级：</strong>{classInfo.grade || '-'}</p>
              <p><strong>所属学校：</strong>{classInfo.school_name || '-'}</p>
              <p><strong>班级口令：</strong>{classInfo.token}</p>
              <p><strong>创建时间：</strong>{classInfo.created_at ? new Date(classInfo.created_at).toLocaleString() : '-'}</p>
              
              <Divider />
              
              <div style={{ marginBottom: 16 }}>
                <p style={{ marginBottom: 8 }}>
                  <UserOutlined style={{ marginRight: 8 }} />
                  <strong>班主任：</strong>
                </p>
                {classInfo.head_teacher ? (
                  <Card size="small" style={{ maxWidth: 400 }}>
                    <p style={{ margin: '4px 0' }}><strong>姓名：</strong>{classInfo.head_teacher.name}</p>
                    {classInfo.head_teacher.phone && (
                      <p style={{ margin: '4px 0' }}><strong>电话：</strong>{classInfo.head_teacher.phone}</p>
                    )}
                    {classInfo.head_teacher.email && (
                      <p style={{ margin: '4px 0' }}><strong>邮箱：</strong>{classInfo.head_teacher.email}</p>
                    )}
                  </Card>
                ) : (
                  <Tag color="default">管理员创建</Tag>
                )}
              </div>
              
              <Divider />
              
              <div>
                <p style={{ marginBottom: 8 }}>
                  <TeamOutlined style={{ marginRight: 8 }} />
                  <strong>加入的教师：</strong>
                  {classInfo.joined_teachers && classInfo.joined_teachers.length > 0 && (
                    <Tag color="blue" style={{ marginLeft: 8 }}>
                      {classInfo.joined_teachers.length}人
                    </Tag>
                  )}
                </p>
                {classInfo.joined_teachers && classInfo.joined_teachers.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {classInfo.joined_teachers.map((teacher) => (
                      <Card key={teacher.id} size="small" style={{ maxWidth: 400 }}>
                        <p style={{ margin: '4px 0' }}><strong>姓名：</strong>{teacher.name}</p>
                        {teacher.phone && (
                          <p style={{ margin: '4px 0' }}><strong>电话：</strong>{teacher.phone}</p>
                        )}
                        {teacher.email && (
                          <p style={{ margin: '4px 0' }}><strong>邮箱：</strong>{teacher.email}</p>
                        )}
                        <p style={{ margin: '4px 0', color: '#999', fontSize: 12 }}>
                          <strong>加入时间：</strong>
                          {teacher.joined_at ? new Date(teacher.joined_at).toLocaleString() : '-'}
                        </p>
                      </Card>
                    ))}
                  </div>
                ) : (
                  <Tag color="default">暂无教师加入</Tag>
                )}
              </div>
            </div>
          </TabPane>

          <TabPane tab="课程表管理" key="schedule">
            <CourseScheduleManagement classId={classId} classInfo={classInfo} />
          </TabPane>

          <TabPane tab="值日生管理" key="duty">
            <DutyStudentManagement classId={classId} classInfo={classInfo} />
          </TabPane>

          <TabPane tab="座位管理" key="seat">
            <SeatManagement classId={classId} classInfo={classInfo} />
          </TabPane>

          <TabPane tab="家长绑定管理" key="binding">
            <StudentBindingManagement classId={classId} />
          </TabPane>

          <TabPane tab="二维码管理" key="qrcodes">
            <ClassQRCodeManagement classId={classId} classInfo={classInfo} />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default ClassDetailManagement;

